import {
    ArrowLeftIcon,
    CheckCircleIcon,
    DocumentTextIcon,
    ShieldCheckIcon,
} from "@heroicons/react/24/outline";

const forms = {
    training: {
        title: "Վերապատրաստումներ",
        description: "Լրացրեք հայտը՝ վերապատրաստմանը մասնակցելու համար։",
        url: "https://docs.google.com/forms/d/e/1FAIpQLSfHn-7jKkuaGZa4eZ3JhYm-SlsmzsHIsYyBfQ89hbL7WGoGEQ/viewform?embedded=true",
        gradient: "from-emerald-700 via-emerald-600 to-teal-600",
    },
    scenario: {
        title: "Սցենար",
        description: "Ներկայացրեք միջոցառման տվյալները և անհրաժեշտ մանրամասները։",
        url: "https://docs.google.com/forms/d/e/1FAIpQLSfPXW8l1qw5Xu6bywAeMrrW7G52YbqplCKC-uqT8lTNanbU4g/viewform?embedded=true",
        gradient: "from-amber-600 via-orange-500 to-rose-500",
    },
    "lesson-plan": {
        title: "Դասի պլան",
        description: "Լրացրեք դասի տվյալները՝ համապատասխան պլանը ստանալու համար։",
        url: "https://docs.google.com/forms/d/e/1FAIpQLSdAM2THkjD3AH0GaUvlawUnSfI2twwdMavrjtniI9QJw8DOQQ/viewform?embedded=true",
        gradient: "from-sky-700 via-blue-600 to-indigo-600",
    },
    other: {
        title: "Կրթական ոլորտի այլ ծառայություն",
        description: "Նկարագրեք Ձեր կարիքը՝ համապատասխան ծառայությունը ընտրելու համար։",
        url: "https://docs.google.com/forms/d/e/1FAIpQLSefZ22EpWS61ObmnuR3e9QQ-0ZMFRiKCq0wmwlzGsO40eymiQ/viewform?embedded=true",
        gradient: "from-rose-700 via-pink-600 to-violet-600",
    },
};

export default function EmbeddedApplicationForm({ formType }) {
    const form = forms[formType] || forms.training;

    return (
        <main className="relative min-h-screen overflow-hidden bg-slate-50 px-4 py-6 sm:px-6 sm:py-10">
            <div className="pointer-events-none absolute -left-32 -top-32 h-80 w-80 rounded-full bg-emerald-100 blur-3xl" />
            <div className="pointer-events-none absolute -bottom-32 -right-24 h-96 w-96 rounded-full bg-violet-100 blur-3xl" />

            <div className="relative mx-auto max-w-5xl">
                <a
                    href="/?page=application"
                    className="inline-flex items-center gap-2 rounded-full bg-white px-4 py-2 text-sm font-semibold text-slate-700 shadow-sm ring-1 ring-slate-200 transition hover:-translate-x-1 hover:text-emerald-700"
                >
                    <ArrowLeftIcon className="h-4 w-4" />
                    Վերադառնալ բաժիններին
                </a>

                <section className="mt-8 overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-xl shadow-slate-200/70 sm:mt-10">
                    <div className={`bg-gradient-to-br ${form.gradient} px-6 py-9 text-white sm:px-10 lg:px-12`}>
                        <span className="inline-flex items-center gap-2 rounded-full bg-white/15 px-4 py-2 text-sm font-bold ring-1 ring-white/25">
                            <DocumentTextIcon className="h-5 w-5" />
                            Առցանց հայտ
                        </span>
                        <h1 className="mt-5 text-3xl font-bold tracking-tight sm:text-5xl">
                            {form.title}
                        </h1>
                        <p className="mt-4 max-w-2xl text-base leading-7 text-white/90 sm:text-lg">
                            {form.description}
                        </p>

                        <div className="mt-7 flex flex-wrap gap-3 text-sm font-semibold">
                            <span className="inline-flex items-center gap-2 rounded-2xl bg-white/15 px-4 py-3 ring-1 ring-white/20">
                                <CheckCircleIcon className="h-5 w-5" />
                                Պարզ լրացում
                            </span>
                            <span className="inline-flex items-center gap-2 rounded-2xl bg-white/15 px-4 py-3 ring-1 ring-white/20">
                                <ShieldCheckIcon className="h-5 w-5" />
                                Անվտանգ Google Form
                            </span>
                        </div>
                    </div>

                    <div className="bg-slate-100 p-2 sm:p-5 lg:p-7">
                        <iframe
                            src={form.url}
                            title={`${form.title} հայտի ձև`}
                            className="h-[1100px] w-full rounded-2xl border-0 bg-white sm:h-[1200px]"
                            loading="eager"
                            credentialless=""
                        />

                        <p className="px-4 pb-3 pt-5 text-center text-sm text-slate-500">
                            Եթե ձևը չի բացվում, օգտագործեք{" "}
                            <a
                                href={form.url.replace("?embedded=true", "")}
                                target="_blank"
                                rel="noreferrer"
                                className="font-bold text-emerald-700 underline underline-offset-4"
                            >
                                ուղիղ հղումը
                            </a>
                            ։
                        </p>
                    </div>
                </section>
            </div>
        </main>
    );
}
